// extracted by mini-css-extract-plugin
export default {"objects":"Objects_objects__0HO5X"};